import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const SPARKLE_DURATION_MS = 6_000;

interface TodayRenameNavHighlightContextValue {
  navSparkleActive: boolean;
  triggerNavSparkle: () => void;
}

const TodayRenameNavHighlightContext = createContext<TodayRenameNavHighlightContextValue | null>(
  null,
);

export function TodayRenameNavHighlightProvider({ children }: { children: React.ReactNode }) {
  const [navSparkleActive, setNavSparkleActive] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const triggerNavSparkle = useCallback(() => {
    setNavSparkleActive(true);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      setNavSparkleActive(false);
      timeoutRef.current = null;
    }, SPARKLE_DURATION_MS);
  }, []);

  return (
    <TodayRenameNavHighlightContext.Provider value={{ navSparkleActive, triggerNavSparkle }}>
      {children}
    </TodayRenameNavHighlightContext.Provider>
  );
}

export function useTodayRenameNavHighlight(): TodayRenameNavHighlightContextValue {
  const ctx = useContext(TodayRenameNavHighlightContext);
  if (!ctx) {
    throw new Error("useTodayRenameNavHighlight must be used within TodayRenameNavHighlightProvider");
  }
  return ctx;
}
